import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitUpdateProfile = {
  name?: string;
};

export const updateProfile = async (data: SubmitUpdateProfile) => {
  const response = await axios.post(`${rootUrl}/psychologist/update/profile`, {
    name: data.name,
    token: getCookies('auth'),
  });

  return response.data;
};
